import React from 'react';
import PropTypes from 'prop-types';

function BlogContent({ content }) {
  if (!content || !Array.isArray(content)) {
    return null;
  }

  return (
    <div className="prose prose-invert max-w-none">
      {content.map((block, index) => {
        // Using index as key is acceptable here since content blocks
        // are static and won't be reordered dynamically
        const key = `${block.type}-${index}`;

        switch (block.type) {
          case 'paragraph':
            return (
              <p
                key={key}
                className="text-gray-300 text-lg leading-relaxed mb-6"
              >
                {block.text}
              </p>
            );

          case 'heading':
            if (block.level === 2) {
              return (
                <h2
                  key={key}
                  className="text-3xl font-bold text-cyan-400 mb-4 mt-8"
                >
                  {block.text}
                </h2>
              );
            }
            if (block.level === 3) {
              return (
                <h3
                  key={key}
                  className="text-2xl font-bold text-cyan-400 mb-3 mt-6"
                >
                  {block.text}
                </h3>
              );
            }
            return null;

          case 'image':
            return (
              <figure key={key} className="my-8">
                <img
                  src={block.src}
                  alt={block.alt}
                  className="w-full rounded-lg"
                />
                {block.caption && (
                  <figcaption className="text-center text-gray-400 text-sm mt-2">
                    {block.caption}
                  </figcaption>
                )}
              </figure>
            );

          case 'code':
            return (
              <pre
                key={key}
                className="bg-gray-800 border border-gray-700 rounded-lg p-4 overflow-x-auto mb-6"
              >
                <code className="text-cyan-400 text-sm font-mono">
                  {block.code}
                </code>
              </pre>
            );

          default:
            return null;
        }
      })}
    </div>
  );
}

BlogContent.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      text: PropTypes.string,
      level: PropTypes.number,
      src: PropTypes.string,
      alt: PropTypes.string,
      caption: PropTypes.string,
      code: PropTypes.string,
      language: PropTypes.string,
    }),
  ).isRequired,
};

export default BlogContent;
